
import React from 'react';
import { ResourceFile } from "../../types";
import { 
  determineResourceType, 
  isSpecialCaseVideo
} from "../../utils/fileTypeUtils";
import { TrainingVideoContentViewer } from "../TrainingVideoContentViewer";
import { TrainingPDFContentViewer } from "../TrainingPDFContentViewer";
import { TrainingFallbackContentViewer } from "../TrainingFallbackContentViewer";

interface MediaContentTypeHandlerProps {
  currentFile: ResourceFile;
  resourceId: string;
  isTrainee: boolean;
  isAdmin: boolean;
  handleContentComplete: () => void;
  onError: (error: string) => void;
}

export function MediaContentTypeHandler({
  currentFile,
  resourceId,
  isTrainee,
  isAdmin,
  handleContentComplete,
  onError
}: MediaContentTypeHandlerProps) {
  // Handle special case video files using our utility function
  if (currentFile.file_url && isSpecialCaseVideo(currentFile.file_url)) {
    console.log('MediaContentTypeHandler: Using special case video handler for:', currentFile.file_url);
    
    return (
      <TrainingVideoContentViewer
        fileUrl={currentFile.file_url}
        fileId={currentFile.id}
        resourceId={resourceId}
        onComplete={handleContentComplete}
        onError={onError}
      />
    );
  }

  // Regular PDF or Video content
  const fileType = currentFile.resourceType || determineResourceType(currentFile.file_url, currentFile.file_type);
  
  console.log('Rendering content for file:', {
    fileId: currentFile.id,
    title: currentFile.title,
    url: currentFile.file_url,
    type: fileType,
    detectedType: determineResourceType(currentFile.file_url, currentFile.file_type),
    providedType: currentFile.file_type
  });

  if (fileType === 'pdf') {
    return (
      <TrainingPDFContentViewer
        fileUrl={currentFile.file_url || ''}
        isTrainee={isTrainee}
        isAdmin={isAdmin}
        onComplete={handleContentComplete}
      />
    );
  }
  
  if (fileType === 'video') {
    return (
      <TrainingVideoContentViewer
        fileUrl={currentFile.file_url}
        fileId={currentFile.id}
        resourceId={resourceId}
        onComplete={handleContentComplete}
        onError={onError}
      />
    );
  }

  // Secondary check for videos using our utility function
  if (currentFile.file_url && isSpecialCaseVideo(currentFile.file_url)) {
    console.log('MediaContentTypeHandler: Detected special case video (fallback):', currentFile.file_url);
    
    return (
      <TrainingVideoContentViewer
        fileUrl={currentFile.file_url}
        fileId={currentFile.id}
        resourceId={resourceId}
        onComplete={handleContentComplete}
        onError={onError}
      />
    );
  }

  // Fallback for unsupported content types
  return (
    <TrainingFallbackContentViewer
      fileUrl={currentFile.file_url}
      fileType={currentFile.file_type}
    />
  );
}
